<h2 class="text--h2 text--bold">{{ 'basic_information' | translate }}</h2>
<div class="card-grid">
  <app-information-card
    class="spacing--margin-all mat-elevation-z5"
    [title]="'Profile Information'"
    [ngClass]="{ nonvalid: !profile.isActive }"
  >
    <div>
      <span class="text--bold">Name:</span>
      {{ profile.firstName }} {{ profile.lastName }}
    </div>
    <br />
    <div>
      <span class="text--bold">Email:</span>
      {{ profile.email }}
    </div>
    <br />
    <div>
      <span class="text--bold">Profile Type:</span>
      {{ profile.businessPartnerEntityType }}
    </div>
    <br />
    <div>
      <span class="text--bold">Is Valid:</span>
      {{ profile.isActive === true ? 'Yes' : 'No' }}
    </div>
    <br />
    <div *ngIf="profile?.businessPartnerEntityType === 'Employee'">
      <span class="text--bold">Employee End Date:</span>
      {{ profile.employeeEndDate | date: 'dd-MM-yyyy' }}
    </div>
  </app-information-card>
  <app-information-card
    class="spacing--margin-all mat-elevation-z5"
    [title]="'Developer Information'"
  >
    <div>
      <span class="text--bold">Platform Profile Id:</span>
      {{ profile.profileId }}
    </div>
    <br />
    <div>
      <span class="text--bold">Platform BusinessPartner Id:</span>
      {{ profile.businessPartnerEntityId }}
    </div>
  </app-information-card>
  <app-information-card class="spacing--margin-all mat-elevation-z5" [title]="'User Preferences'">
    <div>
      <span class="text--bold">locale:</span>
      {{ profile.propertiesJson.locale }}
    </div>
    <br />
    <div>
      <span class="text--bold">Selected Customer Id:</span>
      {{ profile.propertiesJson.customerId }}
    </div>
    <br />
    <div>
      <span class="text--bold">Selected Location Id:</span>
      {{ profile.propertiesJson.locationId }}
    </div>
  </app-information-card>
  <app-information-card
    class="spacing--margin-all mat-elevation-z5"
    [title]="'Account - SignUp Status'"
    [ngClass]="{ nonvalid: !b2cProfile?.exists }"
  >
    <div>
      <span class="text--bold">exists:</span>
      {{ b2cProfile?.exists ? 'Yes' : 'No' }}
    </div>
    <br />
    <div>
      <span class="text--bold">B2C Id:</span>
      {{ b2cProfile?.id }}
    </div>
    <br />
    <div>
      <span class="text--bold">Display name:</span>
      {{ b2cProfile?.displayName }}
    </div>
    <br />
    <div>
      <span class="text--bold">UPN:</span>
      {{ b2cProfile?.userPrincipalName }}
    </div>
  </app-information-card>
</div>
